import styled, { css } from 'styled-components';
import { backgroundPrimary } from '@salutejs/plasma-core';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Dropdown/DropdownList');

/**
 * Выпадающий список.
 */
export var DropdownList = /*#__PURE__*/styled.ul.withConfig({
  componentId: "plasma-web-core__sc-ghowbu-0"
})(["margin:0;padding:var(--plasma-dropdown-padding,0);width:100%;height:var(--plasma-dropdown-height,initial);border-radius:var(--plasma-dropdown-border-radius,0);background-color:var(--plasma-dropdown-background,", ");box-shadow:0 0.75rem 1.75rem rgba(0,0,0,0.08);transition:opacity 0.3s ease-in-out;list-style:none;box-sizing:border-box;overflow-y:var(--plasma-dropdown-overflow,initial);"], backgroundPrimary);
export var applyDropdownListCssProperties = function applyDropdownListCssProperties(_ref) {
  var listHeight = _ref.listHeight,
      listOverflow = _ref.listOverflow;
  var computedHeight = !Number.isNaN(Number(listHeight)) ? "".concat(listHeight, "rem") : listHeight;
  return css(["--plasma-dropdown-height:", ";--plasma-dropdown-overflow:", ";"], computedHeight, listOverflow);
};